import { Component, OnInit } from '@angular/core';
import {
	Data, DataLoaderService, CommonDataService, AlternateOptionsService, SortingService,
	PriceCalculationService, ProgressBarService, SummaryValidationService, SummaryService
} from '../service-call-index';
import { SummaryValidationComponent } from './../summary-validations/summary-validations.component';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';
import { Utils } from '../../../../shared/utils';

@Component({
	selector: 'upholstery-options',
	templateUrl: './upholstery.template.html',
	styleUrls: ['./upholstery.component.css'],
})

export class UpholsteryOptions implements OnInit {
	public upholstery: Data[];
	public saved: Data[];
	public toggleContViewUpholstery: boolean = false;
	public currency: string;
	public errMessage;
	public upholsterySuggList = [];
	public lengthOfUpholstery: number;
	public vehicleInfo: any;


	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService, private sortingService: SortingService,
		private summaryService: SummaryService, private summaryValidationService: SummaryValidationService, private vehicleInfoService: VehicleInfoService,
		private priceCalculationService: PriceCalculationService, private alternateOptionsService: AlternateOptionsService,
		private progressService: ProgressBarService, private summaryValidationComponent: SummaryValidationComponent,private alternateScreenComponent: AlternateScreenComponent) {
		this.vehicleInfo = this.vehicleInfoService.extractData();
		this.currency = this.dataLoaderService.data.currencyType;
		this.upholstery = this.dataLoaderService.data.upholstery;
	
		
	}
	ngOnInit() {
		this.summaryService.getSelectedOptions();
		this.summaryValidationService.getSelectedOptions();

		this.progressService.progressBarValidation();

		if (this.commonDataService.upholsteryFlag) {
			this.toggleContViewUpholstery = true;
		}

		//fetching length for displaying in HTML
		this.lengthOfUpholstery = this.dataLoaderService.data.upholstery.length;

		//On load	
		let upholstery;
		this.upholstery.forEach(element => {
			if (element.selected === true) {
				upholstery = element;
				this.saved = upholstery;
				this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [upholstery] });
			}
		});
		
	}
	/**
	 * To select a color option and send the selected option to the Summary screen
	 * @param item of Data type
	 * @returns none
	 */

	selectUpholstery(item) {
			setTimeout(() => {
				this.progressService.illuminateRed();
			}, 0);
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.dataLoaderService.flagDictionary.resetUpholsteryFlag = false;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.upholsterySuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.upholsterySuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						this.commonDataService.progressBarNewOrderUpholsteryFlag = true;
					}
					else {
						for (let i in this.upholstery) {
							if (this.upholstery[i].code === item.code) {
								this.upholstery[i].selected = true;
									//Updated prices from validation response
								for (let s in this.dataLoaderService.gccUpdatedPrices) {
									for(let k in this.upholstery){
										if (this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
											this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
									    }
									}
								}
								this.dataLoaderService.previousExpertUpholstery[0] = this.upholstery[i]
							} else {
								this.upholstery[i].selected = false;
										//Updated prices from validation response
								for (let s in this.dataLoaderService.gccUpdatedPrices) {
									for(let k in this.upholstery){
										if (this.upholstery[k].code == this.dataLoaderService.gccUpdatedPrices[s].code && this.upholstery[k].codeType == this.dataLoaderService.gccUpdatedPrices[s].codeType) {
											this.upholstery[k].price = this.dataLoaderService.gccUpdatedPrices[s].price;
										}
									}
								}
							}
						
						}
						this.saved = item;
						this.commonDataService.progressBarNewOrderUpholsteryFlag = true;
						this.dataLoaderService.flagDictionary.validated = false;
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
						if(this.commonDataService.progressBarNewOrderColorFlag == true && this.commonDataService.progressBarNewOrderUpholsteryFlag == true){
							setTimeout(() => {
								this.progressService.illuminateGreen();
								this.dataLoaderService.flagDictionary.validated = true;
							}, 0);
						}
						this.saveUpholstery();
					}
					this.sortingService.sortCodes(this.upholstery, true)
					
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.upholstery) {
				if (this.upholstery[i].code === item.code) {
					this.upholstery[i].selected = true;
				} else {
					this.upholstery[i].selected = false;
				}
			}
			this.saved = item;
			this.dataLoaderService.flagDictionary.validated = false;
			this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
			this.dataLoaderService.flagDictionary.loadingFlag = false;
			this.sortingService.sortCodes(this.upholstery, true)
			this.saveUpholstery();
		}
		this.progressService.progressBarValidation();
	}


	/**
	 * To go to the next Tab: Additional Color tab when clicked on the Continue button
	 * @param none
	 * @returns none
	 */
	gotoNextTab() {
		if(this.isMarketCA_N()||this.isMarketCA_T()||this.isMarketMX()){
			this.commonDataService.notifyOther({ option: 'activePackage' });
		}else{
			this.commonDataService.notifyOther({ option: 'activeRim' });
		}
	
	}
	saveUpholstery() {
		if (this.saved !== undefined) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.saved] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertUpholstery", data: [this.saved] });
			this.priceCalculationService.normalModePriceCalculation();
		}
		this.progressService.progressBarValidation();
	}
	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();

	}
	validate() {
		// this.dataLoaderService.flagDictionary.normalValidSummary = false;
		this.summaryValidationComponent.alternateOptionsForURLFlag2Validate();
	}
	isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
	}
	isMarketMX(){
		return Utils.isCountryMX(this.vehicleInfo.orderingMarket);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/upholstery/upholstery.component.ts